export default {
    name: 'EmptyLayout',
    components: {},
    data() {
        return {}
    },
}

